<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5625 9.75H14.4375C14.3344 9.75 14.25 9.83437 14.25 9.9375V12.5625C14.25 12.6656 14.3344 12.75 14.4375 12.75H15.5625C15.6656 12.75 15.75 12.6656 15.75 12.5625V11.25H17.1562V18.75H16.0781C15.975 18.75 15.8906 18.8344 15.8906 18.9375V20.0625C15.8906 20.1656 15.975 20.25 16.0781 20.25H19.9219C20.025 20.25 20.1094 20.1656 20.1094 20.0625V18.9375C20.1094 18.8344 20.025 18.75 19.9219 18.75H18.8438V11.25H20.25V12.5625C20.25 12.6656 20.3344 12.75 20.4375 12.75H21.5625C21.6656 12.75 21.75 12.6656 21.75 12.5625V9.9375C21.75 9.83437 21.6656 9.75 21.5625 9.75ZM15.375 6.9375V3.9375C15.375 3.83437 15.2906 3.75 15.1875 3.75H2.4375C2.33437 3.75 2.25 3.83437 2.25 3.9375V6.9375C2.25 7.04063 2.33437 7.125 2.4375 7.125H3.75C3.85312 7.125 3.9375 7.04063 3.9375 6.9375V5.4375H7.875V18.5625H5.71875C5.61562 18.5625 5.53125 18.6469 5.53125 18.75V20.0625C5.53125 20.1656 5.61562 20.25 5.71875 20.25H11.9062C12.0094 20.25 12.0938 20.1656 12.0938 20.0625V18.75C12.0938 18.6469 12.0094 18.5625 11.9062 18.5625H9.75V5.4375H13.6875V6.9375C13.6875 7.04063 13.7719 7.125 13.875 7.125H15.1875C15.2906 7.125 15.375 7.04063 15.375 6.9375Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'FontSize' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
